module.exports = __webpack_public_path__ + "img/back-caret.dd505a24.svg";